import React, { useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';
import './RFISending.scss';
import { BridgeApiTemplate, InternalApiAlertRfi } from '../api-internal';
import { RFIData } from './useRfiData';
import { counterpartiesNames, getRequestedFieldsDisplayValue } from './helper';
import { ApiMatchSource, ApiMatchSourceType } from '../api';
import ShowHideButton from '../common/ShowHideButton';

export interface RFIAttributesProps {
  rfiData?: RFIData;
  matchSources?: ApiMatchSource[];
}

function getData(rfi: InternalApiAlertRfi, rfiTemplate: BridgeApiTemplate, matchSourcesFields: string[]) {
  return Object.entries(rfi.response!)
    .sort((a, b) => {
      // Need to sort them to be in correct order
      const aField = rfiTemplate.requestedFields.find((requestedField) => requestedField.name === a[0])!;
      const bField = rfiTemplate.requestedFields.find((requestedField) => requestedField.name === b[0])!;
      if (aField && bField) {
        return aField.sortOrder - bField.sortOrder;
      } else {
        return 0;
      }
    })
    .map(([field, value], index, array) =>
      getRequestedFieldsDisplayValue(
        field,
        value,
        [...rfiTemplate.requestedFields, ...(rfi.requestedFields ? rfi.requestedFields.custom : [])],
        counterpartiesNames(rfi),
        index < array.length - 1,
        matchSourcesFields.includes(field)
      )
    );
}

export const RFIAttributes = ({ rfiData, matchSources = [] }: RFIAttributesProps) => {
  const [expanded, setExpanded] = useState(true);

  if (!rfiData?.rfi?.response || !rfiData.rfiTemplate) {
    return <></>;
  }
  const sourceFields = matchSources
    .filter((it) => it.type === ApiMatchSourceType.RFI)
    .flatMap((it) => (it.fieldKey ? it.fieldKey?.split(' ') : []));
  return (
    <Card>
      <Card.Header className='cursor-pointer' onClick={() => setExpanded(!expanded)}>
        <h4 className='card-header-title'>Additional details</h4>
        <ShowHideButton expanded={expanded} />
      </Card.Header>
      <Collapse in={expanded}>
        <Card.Body>{getData(rfiData.rfi, rfiData.rfiTemplate, sourceFields)}</Card.Body>
      </Collapse>
    </Card>
  );
};

export default RFIAttributes;
